/**
 * Run economy state (TRD-07 §2).
 *
 * TRD-01 owns the shape so `World` and `UiSnapshot` are complete and TRD-09 can be built
 * against a real type. TRD-07 owns every rule: shop rolls, reroll costs, merging,
 * placement budget, payout.
 */
import type { StarLevel, TowerId } from './types.js';

export interface BenchItem {
  defId: TowerId;
  star: StarLevel;
  investedGold: number;
}

export interface ShopSlot {
  defId: TowerId;
  cost: number;
}

export interface EconomyState {
  gold: number;
  /** Cumulative INCOME, never decremented — scoring counts what you earned, not what you
   *  hoarded, so that sitting on gold does not beat playing (TRD-06 R-06-23). */
  goldEarnedTotal: number;
  placementsLeft: number;
  placementsPerRound: number;
  benchSlots: number;
  bench: (BenchItem | null)[];
  shop: (ShopSlot | null)[];
  rerollsThisRound: number;
  /** R-07-26 — a locked shop survives the wave-clear reroll (backlog B-14). */
  shopLocked: boolean;
}

export function createEconomyState(
  startingGold: number,
  benchSlots: number,
  shopSlots: number,
  placementsPerRound: number,
): EconomyState {
  return {
    gold: startingGold,
    goldEarnedTotal: startingGold,
    placementsLeft: placementsPerRound,
    placementsPerRound,
    benchSlots,
    bench: new Array<BenchItem | null>(benchSlots).fill(null),
    shop: new Array<ShopSlot | null>(shopSlots).fill(null),
    rerollsThisRound: 0,
    shopLocked: false,
  };
}
